// @flow

import React, { Component } from 'react';

import ContentBloc from 'components/newsletter/blocs/ContentBloc';
import CompetitionOverHome from 'components/competitionsInternationales/competitionsInternationalesHomeOver';
import type { CompetitionInternationale } from 'types/competitionsInternationales';
import type { Status } from 'types/Status';

export type StateProps = {
  data: CompetitionInternationale,
  status: Status
};

export default class CompetitionsInternationalesHome extends Component<StateProps> {
  render() {
    const { data } = this.props;

    return (
      <>
        {!data.meta.statut_competition !== 'terminee' && !!data.content.data && !!data.content.data.length && (
          <div className="home">
            {data.content.data.map((bloc, index) => (
              <ContentBloc key={index} {...bloc} />
            ))}
          </div>
        )}

        {data.meta.statut_competition === 'terminee' && (
          <div className="home home--post-competition">
            <CompetitionOverHome data={data} />
          </div>
        )}
      </>
    );
  }
}
